import ApiClient from '~/ApiClient';

import { ReferencedProductType } from './ReferencedProductType';

export interface Result {
	items: ReferencedProductType[];
}

export async function findReferencedProductTypes(client: ApiClient): Promise<Result> {
	const request = await client.fetch('hr-price-referencing/max-price/referenced-product-types');
	const response = await request.json();
	return {
		items: response.items.map((type: { id: string; title: string }) => new ReferencedProductType(type.id, type.title)),
	};
}
